import { InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from './../authConfig';

export async function getAccessTokenAsync(msalInstance: IPublicClientApplication, forceRefresh = false) {
    const account = msalInstance.getAllAccounts()[0];

    // Redirect to login
    if (!account) {
        await msalInstance.loginRedirect();
        return Promise.reject('Redirect initiated for login');
    }

    const tokenRequest = {
        ...loginRequest,
        account,
        forceRefresh,
    };

    try {
        // Attempt to get the token silently first
        const silentResult = await msalInstance.acquireTokenSilent(
            tokenRequest
        );
        return silentResult.accessToken;
    } catch (err: any) {
        const isInteractionRequired =
            err instanceof InteractionRequiredAuthError ||
            err?.errorCode === 'interaction_required' ||
            err?.errorCode === 'login_required' ||
            err?.errorCode === 'consent_required' ||
            /AADSTS(70043|50058|50076|50079|53000|53001|53002|53003)/.test(err?.errorMessage ?? '');

        if (isInteractionRequired) {
            await msalInstance.acquireTokenRedirect(tokenRequest);
            return Promise.reject('Redirect initiated for token');
        }
        throw err;
    }
}
